import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface OrdersDto {
  loading: boolean;
  data: any[];
}

export const getOrders = createAsyncThunk("orders/getOrders", async () => {
  const response: any = await axios.get(APIRoutes.ORDERS);
  if (response.data?.statusCode) {
    utils.toastError(response.data?.message);
    return;
  }
  return { data: response?.data?.data ?? [] };
});

export const changeOrderStatus = createAsyncThunk(
  "orders/changeOrderStatus",
  async ({ data }: any) => {
    console.log(
      "url",
      `${APIRoutes.CHANGE_ORDER_STATUS}/${data?.orderId ?? ""}`
    );
    const response: any = await axios.patch(
      `${APIRoutes.CHANGE_ORDER_STATUS}/${data?.orderId ?? ""}`,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

const initialState: OrdersDto = {
  loading: false,
  data: [],
};

export const orders = createSlice({
  name: "orders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrders.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data;
      })
      .addCase(getOrders.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default orders.reducer;
